/**
 * @generated SignedSource<<1c16cc665a7926d00e0d9152dca81f9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InviteeOverview$data = {
  readonly invitations: {
    readonly attendingCount: number;
    readonly count: number;
  } | null;
  readonly " $fragmentType": "InviteeOverview";
};
export type InviteeOverview$key = {
  readonly " $data"?: InviteeOverview$data;
  readonly " $fragmentSpreads": FragmentRefs<"InviteeOverview">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InviteeOverview",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventInvitationConnection",
      "kind": "LinkedField",
      "name": "invitations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": "attendingCount",
          "args": [
            {
              "kind": "Literal",
              "name": "rsvpState",
              "value": "ATTENDING"
            }
          ],
          "kind": "ScalarField",
          "name": "count",
          "storageKey": "count(rsvpState:\"ATTENDING\")"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "c3ec7372816d505195c7364854c794cd";

export default node;
